<template>
  <v-container style="height: 100%;" class="ma-0 pa-5" fluid>
    <div class="d-flex flex-row align-center">
      <v-text-field v-model="search" label="Search..."></v-text-field>

      <v-btn @click="load()" color="success" class="ml-5" icon>
        <v-icon>mdi-refresh-circle</v-icon>
      </v-btn>

      <v-btn @click="logout()" color="red" class="ml-5" icon>
        <v-icon>mdi-exit-run</v-icon>
      </v-btn>
    </div>

    <v-data-table :headers="headers" :items="rows" :items-per-page="15" class="elevation-1" :search="search"
      :loading="loading">

      <template v-slot:[`item.custom_appointment`]="{ item }">
        <span v-if="item.x_studio_appuntamento">
          {{ formatDate(item.x_studio_appuntamento) }}
        </span>
      </template>

      <template v-slot:[`item.custom_actions`]="{ item }">
        <v-btn @click="openItem(item)" color="primary" class="ml-5" icon>
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </template>
    </v-data-table>


    <v-dialog v-model="detailDialogShow" width="500">
      <v-card>
        <v-card-title>Detail {{ detailDialogData.x_studio_tgu }}</v-card-title>

        <v-card-text>
          Monitoring IP: {{ detailDialogData.x_studio_ip_monitoraggio || 'N/D' }} <br><br>

          Start Date: {{ formatDate(detailDialogData.x_studio_data_attivazione) }} <br>
          End Date: {{ formatDate(detailDialogData.x_studio_data_fine_servizio) }} <br>
        </v-card-text>
      </v-card>

    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'List',

  data: () => ({
    search: '',

    detailDialogShow: false,
    detailDialogData: {},

    loading: true,
    rows: [],
    headers: [
      { text: 'TGU', value: 'custom_tgu', width: 200 },
      { text: 'Site', value: 'x_studio_site', width: 300 },
      { text: 'Address', value: 'x_name' },
      { text: 'Appointment', value: 'custom_appointment', width: 250 },
      { text: 'Status', value: 'x_studio_selection_field_562_1idho8mrs', width: 250 },
      { text: 'Contract', value: 'contract_name', width: 300 },
      { text: '', value: 'custom_actions', width: 50 },
    ]
  }),

  mounted() {
    let _ = this

    _.load()
  },

  methods: {
    async load() {
      let _ = this

      _.loading = true

      try {
        const data = (await _.$http.get('/wan/subs')).body

        data.forEach(item => {
          item.custom_tgu = item.x_studio_tgu ? item.x_studio_tgu : 'N/D'
          item.contract_name = item.x_studio_contratto[1]
        })

        _.rows = data
      } catch (e) {
        _.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: e.message
        })
      } finally {
        _.loading = false
      }
    },

    openItem(item) {
      let _ = this

      _.detailDialogData = { ...item }
      _.detailDialogShow = true
    },

    formatDate(date) {
      if (!date || date.length === 0) return 'N/D'

      if (date.includes(':')) return moment(date).utcOffset('+0200').format('DD/MM/YYYY HH:mm:ss')
      else return moment(date).format('DD/MM/YYYY')
    },

    logout() {
      let _ = this

      localStorage.removeItem('jwt')
      _.$router.push('/login')
    }
  }
}
</script>